import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from './ui/card';
import { ArrowUpRight } from 'lucide-react';
import { services } from '../mockData';

const Services = () => {
  return (
    <section id="servizi" className="relative bg-black py-24 overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-blue-950/5 to-black" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            <span className="text-gray-500">I nostri</span>{' '}
            <span className="text-white">Servizi</span>
          </h2>
          <p className="text-gray-400 text-lg leading-relaxed">
            Offriamo un servizio completo che permette di managerializzare la tua attività sui Social, 
            trasformando radicalmente la tua presenza digitale, consolidandone un posizionamento forte 
            ed incrementando la redditività della tua iniziativa.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {services.map((service, index) => (
            <div
              key={service.id}
              className="group cursor-default"
            >
              <Card className="h-full bg-white/5 border-white/10 hover:bg-white/10 hover:border-blue-500/50 transition-all duration-500 p-8 rounded-2xl backdrop-blur-sm">
                {/* Service Number */}
                <div className="text-6xl font-bold text-white/10 mb-4 group-hover:text-blue-500/20 transition-colors duration-500">
                  {service.id}
                </div>

                {/* Service Title */}
                <div className="flex items-start justify-between mb-4">
                  <h3 className="text-2xl font-bold text-white group-hover:text-blue-400 transition-colors duration-300">
                    {service.title}
                  </h3>
                  <ArrowUpRight className="h-6 w-6 text-gray-500 group-hover:text-blue-400 group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300" />
                </div>

                {/* Description */}
                <p className="text-gray-400 text-sm mb-6 leading-relaxed">
                  {service.description}
                </p>

                {/* Services List */}
                <div className="space-y-2 mb-6">
                  <div className="text-xs font-semibold text-gray-500 uppercase tracking-wider">
                    Servizi
                  </div>
                  {service.services.map((item, idx) => (
                    <div
                      key={idx}
                      className="text-sm text-gray-400 group-hover:text-white transition-colors"
                    >
                      {item}
                    </div>
                  ))}
                </div>
              </Card>
            </div>
          ))}
        </div>

        {/* Partnership Note */}
        <div>
          <p className="text-gray-400 text-lg leading-relaxed">
            Le attività di Supporto Legale e Business Administration vengono erogate attraverso 
            il coinvolgimento dei Partner Qualificati con cui abbiamo instaurato un rapporto di 
            collaborazione continuativa: essendo infatti un team di esperti in materia di Digital 
            e Social Media Marketing abbiamo deciso di instaurare delle vere e proprie partnership 
            con Avvocati e Dottori Commercialisti esperti in materia per poter erogare in combinata 
            un servizio completo ai Creator, che in questo modo dovranno occuparsi esclusivamente 
            di ciò che più li appassiona con la tranquillità di essere supportati da un Gruppo di 
            Professionisti Specializzati.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Services;